import React, { useMemo } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import merge from "lodash/merge";
import BaseOptionChart from "../../../components/chart/BaseOptionChart";

// Cores graduadas — vermelho pra 1, verde pra 5. Ajuda o olho a ler antes
// mesmo de processar o número.
const STAR_COLORS = ["#ef4444", "#f97316", "#eab308", "#84cc16", "#22c55e"];

const RatingDistribution = ({ distribution = [0, 0, 0, 0, 0], csat = 0, ratedPct = 0, loading = false }) => {
  const total = distribution.reduce((a, b) => a + b, 0);

  const options = useMemo(
    () =>
      merge(BaseOptionChart(), {
        colors: STAR_COLORS,
        chart: { toolbar: { show: false } },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 4,
            distributed: true,
          },
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
          categories: ["1★", "2★", "3★", "4★", "5★"],
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: { labels: { formatter: (v) => Math.round(v) } },
        tooltip: {
          y: {
            formatter: (val) => {
              const pct = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
              return `${val} avaliações (${pct}%)`;
            },
          },
        },
      }),
    [total]
  );

  const series = [{ name: "Avaliações", data: distribution.map((n) => Number(n) || 0) }];

  return (
    <Card elevation={0} sx={{ border: 1, borderColor: "divider", borderRadius: 2, height: "100%" }}>
      <CardHeader
        title="Avaliação dos atendimentos"
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
        subheader={
          total > 0
            ? `${total} avaliações · ${ratedPct}% de cobertura`
            : "Sem avaliações no período"
        }
        subheaderTypographyProps={{ variant: "caption" }}
        action={
          !loading &&
          total > 0 && (
            <Stack alignItems="flex-end" sx={{ pr: 1 }}>
              <Typography variant="caption" color="text.secondary">
                CSAT
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1, color: csat >= 4 ? "success.main" : csat >= 3 ? "warning.main" : "error.main" }}>
                {csat.toFixed(1)}
              </Typography>
            </Stack>
          )
        }
      />
      <CardContent sx={{ pt: 0 }}>
        {loading ? (
          <Skeleton variant="rectangular" height={200} />
        ) : (
          <ReactApexChart options={options} series={series} type="bar" height={220} />
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(RatingDistribution);
